import { appEvents } from "@/shared/lib/events";

export type MarcusOnboardingState = "offered" | "accepted" | "completed" | "dismissed";

const STORAGE_PREFIX = "wiser.marcusOnboarding.v1";
const PLAN_STORAGE_KEY = "marcus-action-plan";

function storageKey(userId: string): string {
  return `${STORAGE_PREFIX}.${userId}`;
}

export function readMarcusOnboardingState(userId: string | null): MarcusOnboardingState | null {
  if (!userId || typeof window === "undefined") return null;
  try {
    const value = window.localStorage.getItem(storageKey(userId));
    if (
      value === "offered" ||
      value === "accepted" ||
      value === "completed" ||
      value === "dismissed"
    ) {
      return value;
    }
  } catch {
    return null;
  }
  return null;
}

export function writeMarcusOnboardingState(
  userId: string,
  state: MarcusOnboardingState,
): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(storageKey(userId), state);
  } catch {
    // Storage failures should not block the tour UI.
  }
}

export function publishOnboardingPrompt(text: string, label: string): void {
  appEvents.publish({
    type: "companion:request-prompt",
    text,
    display: {
      kind: "command",
      label,
      source: "marcus",
    },
  });
}

export function clearPersistedTimeline(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(PLAN_STORAGE_KEY);
  } catch {
    // Non-critical; the next ads_ui_announce_plan call overwrites it.
  }
}
